module.exports = __webpack_public_path__ + "6d4605387757ee962f68805ca7d52bc0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/floatie-toucan-s.png
// module id = 1891
// module chunks = 0